// extracted by mini-css-extract-plugin
export default {"box":"formInput_box__L3MxR","box__input":"formInput_box__input__kHUPX","box__label":"formInput_box__label__HBwFL"};